module.exports = __webpack_public_path__ + "img/sld_step_down_transformer_h_r1_dark.0a86ecfd.svg";